(function () {
  if (window.loadThemeSwiper) return;

  let pending;

  function loadStylesheet(href) {
    return new Promise((resolve) => {
      const existing = document.querySelector(`link[href="${href}"]`);
      if (existing) {
        if (existing.sheet) {
          resolve();
        } else {
          existing.addEventListener('load', () => resolve(), { once: true });
          existing.addEventListener('error', () => resolve(), { once: true });
        }
        return;
      }

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.addEventListener('load', () => resolve(), { once: true });
      link.addEventListener('error', () => resolve(), { once: true });
      document.head.appendChild(link);
    });
  }

  window.loadThemeSwiper = function loadThemeSwiper() {
    if (pending) return pending;

    const cssHref = window.theme?.swiperCssUrl;
    const jsSrc = window.theme?.swiperJsUrl;

    if (!jsSrc) {
      return Promise.reject(new Error('Missing Swiper asset URL'));
    }

    const cssReady = cssHref ? loadStylesheet(cssHref) : Promise.resolve();

    const jsReady = new Promise((resolve, reject) => {
      if (window.Swiper) {
        resolve(window.Swiper);
        return;
      }

      const existing = document.querySelector(`script[src="${jsSrc}"]`);
      if (existing) {
        existing.addEventListener('load', () => resolve(window.Swiper), { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = jsSrc;
      script.defer = true;
      script.onload = () => resolve(window.Swiper);
      script.onerror = () => reject(new Error('Failed to load Swiper'));
      document.head.appendChild(script);
    });

    pending = Promise.all([jsReady, cssReady]).then(([Swiper]) => Swiper);

    return pending;
  };
})();
